import { ACCESSES_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: ACCESSES_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkAccesses'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/accesses/index.js